<template>
  <main class="recipes-page afro-bg">
    <section class="recipes-shell paper-panel">
      <header class="recipes-head">
        <div>
          <p class="eyebrow">Backbar Juliam Arcade</p>
          <h1>Recetario</h1>
          <span>Busca un producto o entra por categoria para consultar ingredientes y preparacion.</span>
        </div>
        <div class="recipe-brand"><span>J</span><strong>ARCADE</strong></div>
      </header>

      <div class="search-line">
        <input v-model="search" class="afro-input" type="search" placeholder="Buscar producto" />
      </div>

      <div v-if="loading" class="state-card">Cargando recetas...</div>
      <div v-else class="recipe-grid">
        <aside class="cat-list afro-section-card">
          <button
            v-for="cat in categoriesWithProducts"
            :key="cat.id_token"
            type="button"
            class="cat-button"
            :class="{ active: selectedCategoryToken === cat.id_token }"
            @click="selectCategory(cat)"
          >
            <span>{{ cat.name }}</span>
            <small>{{ cat.products.length }} productos</small>
          </button>
        </aside>

        <section class="product-list afro-section-card">
          <h2>Productos</h2>
          <button
            v-for="product in filteredProducts"
            :key="product.id_token"
            type="button"
            class="product-button"
            :class="{ active: selectedProduct && selectedProduct.id_token === product.id_token }"
            @click="loadRecipe(product)"
          >
            <span>{{ product.name }}</span>
            <small>{{ productPrice(product) }}</small>
          </button>
          <p v-if="!filteredProducts.length" class="empty-text">No hay productos para mostrar.</p>
        </section>

        <article class="recipe-detail afro-section-card">
          <template v-if="selectedProduct">
            <p class="eyebrow">Receta</p>
            <h2>{{ selectedProduct.name }}</h2>
            <div class="price-pills">
              <span v-if="selectedProduct.has_hot && selectedProduct.price_hot !== null">Caliente {{ money(selectedProduct.price_hot) }}</span>
              <span v-if="selectedProduct.has_cold && selectedProduct.price_cold !== null">Frio {{ money(selectedProduct.price_cold) }}</span>
              <span v-if="selectedProduct.price !== null">{{ money(selectedProduct.price) }}</span>
            </div>

            <h3>Ingredientes</h3>
            <table v-if="selectedProduct.recipe_items && selectedProduct.recipe_items.length">
              <thead><tr><th>Cantidad</th><th>Medida</th><th>Producto</th></tr></thead>
              <tbody>
                <tr v-for="(item, index) in selectedProduct.recipe_items" :key="index">
                  <td>{{ item.quantity || '-' }}</td>
                  <td>{{ item.measure || '-' }}</td>
                  <td>{{ item.item_name }}</td>
                </tr>
              </tbody>
            </table>
            <p v-else class="empty-text">La receta aun no tiene ingredientes capturados.</p>

            <h3>Preparacion</h3>
            <p class="prep-text">{{ selectedProduct.preparation_details || 'Pendiente de capturar.' }}</p>
          </template>
          <template v-else>
            <div class="empty-recipe">
              <span class="empty-controller" aria-hidden="true">＋ · ● ●</span>
              <h2>Selecciona un producto</h2>
              <p>Al elegirlo veras su receta y notas de preparacion.</p>
            </div>
          </template>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import { getPublicMenu, getRecipe } from '@/services/menuApi'
import { connectMenuSocket, closeMenuSocket } from '@/services/menuSocket'

export default {
  name: 'RecipeBrowser',
  data() {
    return {
      loading: true,
      categories: [],
      selectedCategoryToken: '',
      selectedProduct: null,
      search: '',
      socketListener: null
    }
  },
  computed: {
    categoriesWithProducts() {
      return this.categories.filter((cat) => cat.products && cat.products.length)
    },
    selectedCategory() {
      return this.categoriesWithProducts.find((cat) => cat.id_token === this.selectedCategoryToken) || this.categoriesWithProducts[0] || null
    },
    allProducts() {
      return this.categoriesWithProducts.flatMap((cat) => cat.products.map((product) => ({ ...product, category_name: cat.name })))
    },
    filteredProducts() {
      const q = this.search.trim().toLowerCase()
      if (q) {
        return this.allProducts.filter((product) => [product.name, product.category_name].join(' ').toLowerCase().includes(q))
      }
      return this.selectedCategory ? this.selectedCategory.products : []
    }
  },
  async created() {
    await this.loadMenu()
    this.socketListener = (payload) => {
      if (payload?.event === 'loyalty.updated') return
      this.loadMenu(true)
    }
    connectMenuSocket(this.socketListener)
  },
  beforeUnmount() {
    closeMenuSocket(this.socketListener)
  },
  methods: {
    async loadMenu(silent = false) {
      if (!silent) this.loading = true
      try {
        const response = await getPublicMenu()
        this.categories = response.categories || []
        if (!this.selectedCategoryToken && this.categoriesWithProducts.length) {
          this.selectedCategoryToken = this.categoriesWithProducts[0].id_token
        }
      } catch (error) {
        alert('No se pudo cargar el recetario')
      } finally {
        this.loading = false
      }
    },
    selectCategory(cat) {
      this.selectedCategoryToken = cat.id_token
      this.search = ''
      this.selectedProduct = null
    },
    async loadRecipe(product) {
      try {
        const response = await getRecipe(product.id_token)
        this.selectedProduct = response.product
      } catch (error) {
        alert((error.response && error.response.data && error.response.data.error) || 'No se pudo cargar la receta')
      }
    },
    productPrice(product) {
      const pieces = []
      if (product.has_hot && product.price_hot !== null) pieces.push('Cal ' + this.money(product.price_hot))
      if (product.has_cold && product.price_cold !== null) pieces.push('Frio ' + this.money(product.price_cold))
      if (product.price !== null) pieces.push(this.money(product.price))
      return pieces.join(' / ') || 'Sin precio'
    },
    money(value) {
      const n = Number(value)
      return Number.isNaN(n) ? value : `$${n.toFixed(n % 1 === 0 ? 0 : 2)}`
    }
  }
}
</script>

<style scoped>
.recipes-page { min-height: 100vh; padding: 26px; }
.recipes-shell { width: min(1320px, 100%); margin: 0 auto; padding: 26px; }
.recipes-head { display: flex; align-items: center; justify-content: space-between; gap: 20px; text-align: left; border-bottom: 1px solid var(--juliam-line); padding-bottom: 18px; }
.recipe-brand { display: flex; align-items: center; gap: 10px; }
.recipe-brand span { width: 54px; height: 54px; display: grid; place-items: center; border: 2px solid var(--juliam-cyan); color: var(--juliam-pink); font: 900 29px/1 var(--juliam-mono); box-shadow: 0 0 16px rgba(76,245,255,.25); }
.recipe-brand strong { color: var(--juliam-cyan); font: 900 16px/1 var(--juliam-mono); letter-spacing: .1em; }
.eyebrow { margin: 0 0 6px; color: var(--afro-gold); font-weight: 900; letter-spacing: .16em; text-transform: uppercase; }
h1 { margin: 0; font-family: var(--afro-text-serif); font-size: clamp(38px, 5vw, 64px); }
.recipes-head span { color: var(--afro-olive); font-weight: 700; }
.search-line { margin: 18px 0; }
.recipe-grid { display: grid; grid-template-columns: 250px 320px 1fr; gap: 18px; align-items: start; }
.cat-list, .product-list, .recipe-detail { text-align: left; }
.cat-list, .product-list { display: grid; gap: 10px; }
.cat-button, .product-button { border: 1px solid rgba(38,51,31,.18); background: rgba(255,248,230,.68); border-radius: 16px; padding: 13px; text-align: left; cursor: pointer; display: grid; gap: 4px; color: var(--afro-ink); }
.cat-button.active, .product-button.active { background: var(--afro-olive); color: var(--afro-paper-light); }
.cat-button span, .product-button span { font-weight: 900; }
.cat-button small, .product-button small { opacity: .78; }
.product-list h2, .recipe-detail h2 { margin: 0 0 12px; font-family: var(--afro-text-serif); color: var(--afro-olive); }
.recipe-detail h2 { font-size: 38px; color: var(--afro-ink); }
.recipe-detail h3 { color: var(--afro-olive); font-family: var(--afro-text-serif); font-size: 24px; margin: 22px 0 10px; }
.price-pills { display: flex; gap: 8px; flex-wrap: wrap; }
.price-pills span { background: var(--afro-olive); color: #f3dfbd; border-radius: 999px; padding: 7px 11px; font-weight: 900; }
table { width: 100%; border-collapse: collapse; overflow: hidden; border-radius: 14px; }
th, td { padding: 10px; border-bottom: 1px solid rgba(38,51,31,.15); background: rgba(255,248,230,.5); }
th { color: var(--afro-olive); text-transform: uppercase; letter-spacing: .08em; font-size: 12px; }
.prep-text { white-space: pre-line; font-size: 17px; line-height: 1.65; background: rgba(255,248,230,.55); border-radius: 16px; padding: 16px; }
.empty-text { color: var(--afro-olive); font-weight: 700; }
.empty-recipe { min-height: 430px; display: grid; place-items: center; text-align: center; color: var(--afro-olive); }
.empty-controller { padding: 24px 28px; border: 3px solid var(--juliam-cyan); border-radius: 28px; color: var(--juliam-lime); font: 900 28px/1 var(--juliam-mono); box-shadow: 0 0 18px rgba(76,245,255,.22); }
.eyebrow { color: var(--juliam-lime); font: 900 10px/1 var(--juliam-mono); }
h1 { color: var(--juliam-text); font-family: var(--juliam-sans); letter-spacing: -.055em; text-transform: uppercase; }
.recipes-head span, .empty-text, .empty-recipe { color: var(--juliam-muted); }
.cat-button, .product-button { border-color: rgba(255,255,255,.1); background: rgba(5,8,19,.56); border-radius: 10px; color: var(--juliam-text); }
.cat-button.active, .product-button.active { border-color: rgba(76,245,255,.5); background: rgba(76,245,255,.09); color: var(--juliam-cyan); }
.product-list h2, .recipe-detail h2, .recipe-detail h3 { color: var(--juliam-cyan); font-family: var(--juliam-sans); }
.recipe-detail h2 { color: var(--juliam-text); }
.price-pills span { border: 1px solid rgba(167,255,79,.42); border-radius: 8px; background: rgba(167,255,79,.08); color: var(--juliam-lime); }
th, td, .prep-text { border-color: rgba(255,255,255,.09); background: rgba(5,8,19,.5); color: var(--juliam-text); }
th { color: var(--juliam-cyan); }
.prep-text { border-radius: 10px; }
@media (max-width: 1100px) { .recipe-grid { grid-template-columns: 1fr 1fr; } .recipe-detail { grid-column: 1 / -1; } }
@media (max-width: 720px) { .recipes-page { padding: 0; } .recipes-shell { border-radius: 0; padding: 16px; } .recipes-head { flex-direction: column; align-items: flex-start; } .recipe-grid { grid-template-columns: 1fr; } }
</style>
